import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionFeatureActivationContext } from '../types.ts';

export function isTimelineSelectionFeatureEnabled({
  layoutType,
}: SelectionFeatureActivationContext): boolean {
  return layoutType === DatabaseLayoutType.TIMELINE;
}
